import router from './router'
import store from './store'
import { getToken, getTid } from '@/utils/cookies'
import { Message } from 'element-ui'

router.beforeEach(async (to, from, next) => {
    document.title = to.meta.title

    const { domain, tougaoInfo, tougaoSetting, bannerList, realname } = store.getters

    const tid = to.query.tid ? to.query.tid : getTid()

    const hasToken = getToken()
    if (!Object.keys(domain).length) {
        await store.dispatch('tougao/getDomain')
    }

    if (!tougaoInfo || !Object.keys(tougaoInfo).length) {
        await store.dispatch('tougao/getTouGaoInfo', { id: tid })
    }

    if (!Object.keys(tougaoSetting).length) {
        await store.dispatch('tougao/getTouGaoSetting', { tid: tid })
    }

    if (bannerList.length <= 0) {
        await store.dispatch('tougao/getBanner', { tid: tid, type: 10 })
    }

    if (to.path === '/tougao') {
        if (!tid) {
            Message.error('缺少投稿活动的id')
            return false
        }
        const { categoryList } = store.getters
        if (categoryList.length <= 0) {
            await store.dispatch('tougao/getCategoryList', { tid: tid })
        }
    }

    if (hasToken) {
        if (realname) {
            next()
        } else {
            try {
                await store.dispatch('user/getInfo')
                next()
            } catch (error) {
                // remove token and go to login page to re-login
                await store.dispatch('user/resetToken')
                Message.error(error || 'Has Error')
                next(`/login?redirect=${to.path}`)
            }
        }
    } else {
        next()
    }
})

router.afterEach(() => {
    window.scrollTo(0, 0)
})
